<template>
  <div>
    <el-dialog
      class="module-modal-contain"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      width="860px"
      :title="moduleStep ? $t('pop.moduleEdit') : $t('pop.moduleChose')"
    >
      <div
        class="module-modal-page module-modal-page2"
        v-if="!moduleStep"
        v-loading="moduleLoading"
        @click="resetImg"
      >
        <div
          :class="[
            'module-img',
            { nomargin: index % 2 == 0 && index !== 0, active: index === nowIndex },
          ]"
          v-for="(item, index) in moduleList"
          :key="'module' + index"
          @click.stop="choseImg(index)"
        >
          <span class="el-icon-check img-check" v-if="index === nowIndex"></span>
          <img alt="" :src="item.url" />
        </div>
        <div class="module-img-buttons">
          <el-button class="tool-button tool-button-info" type="info" @click="closeChose">
            {{ $t("cancel") }}
          </el-button>
          <el-button
            class="tool-button"
            type="primary"
            @click="goNext"
            :disabled="!imgSrc"
          >
            {{ $t("pop.chose") }}
          </el-button>
        </div>
      </div>
      <div class="module-modal-page" v-else>
        <div class="module-img-edit" ref="moduleImg">
          <img alt="" :src="imgSrc" class="img-back" />
          <VueDragResize
            v-on:resizing="resize"
            v-on:dragging="resize"
            :h="20"
            :w="100"
            :y="100"
            :x="180"
            :minh="12"
            :sticks="['tl', 'tr', 'bl', 'br']"
            :parentLimitation="true"
          >
            <p
              :class="['img-edit-content-title', { bold: font1B, 'font-i': font1I }]"
              :style="{
                fontSize: fontSize1 + 'px',
                textAlign: font1align,
                color: color1,
              }"
            >
              {{ title }}
            </p>
          </VueDragResize>
          <VueDragResize
            v-on:resizing="resize2"
            v-on:dragging="resize2"
            :h="height"
            :w="300"
            :y="300"
            :x="60"
            :minh="12"
            :sticks="['tl', 'tr', 'bl', 'br']"
            :parentLimitation="true"
          >
            <p
              :class="[
                'img-edit-content-title',
                {
                  bold: font2B,
                  'font-i': font2I,
                  'font-sj': width2 / fontSize2 < content.length,
                },
              ]"
              :style="{
                fontSize: fontSize2 + 'px',
                textAlign: font2align,
                color: color2,
              }"
            >
              {{ content }}
            </p>
          </VueDragResize>
          <VueDragResize
            v-on:resizing="resize3"
            v-on:dragging="resize3"
            :h="height"
            :w="100"
            :y="550"
            :x="180"
            :minh="12"
            :sticks="['tl', 'tr', 'bl', 'br']"
            :parentLimitation="true"
          >
            <p
              :class="['img-edit-content-title', { bold: font3B, 'font-i': font3I }]"
              :style="{
                fontSize: fontSize3 + 'px',
                textAlign: font3align,
                color: color3,
              }"
            >
              {{ footer }}
            </p>
          </VueDragResize>
        </div>
        <div class="module-img-data">
          <!-- 标题字体改变 -->
          <div class="data-li clearfix">
            <div class="li-name">{{ $t("bulkmail.title") }}</div>
            <div class="li-value">
              <div class="li-tool clearfix">
                <el-tooltip :content="$t('pop.bfont')" placement="top">
                  <div
                    :class="['tool-module', 'tool-module1', { active: font1B }]"
                    @click="changeFontB1"
                  ></div>
                </el-tooltip>
                <el-tooltip :content="$t('pop.ifont')" placement="top">
                  <div
                    :class="['tool-module', 'tool-module2', { active: font1I }]"
                    @click="changeFontI1"
                  ></div>
                </el-tooltip>
                <div class="tool-module tool-module3">
                  <el-color-picker v-model="color1" size="mini"></el-color-picker>
                </div>
                <el-tooltip :content="$t('pop.lffont')" placement="top">
                  <div
                    :class="['tool-module', 'tool-module4', { active: nowIndex1 === 4 }]"
                    @click="changeFont1(4)"
                  ></div>
                </el-tooltip>
                <el-tooltip :content="$t('pop.centerfont')" placement="top">
                  <div
                    :class="['tool-module', 'tool-module5', { active: nowIndex1 === 5 }]"
                    @click="changeFont1(5)"
                  ></div>
                </el-tooltip>
                <el-tooltip :content="$t('pop.lrfont')" placement="top">
                  <div
                    :class="['tool-module', 'tool-module6', { active: nowIndex1 === 6 }]"
                    @click="changeFont1(6)"
                  ></div>
                </el-tooltip>
                <el-tooltip :content="$t('pop.font')" placement="top">
                  <el-input-number
                    v-model="fontSize1"
                    :min="12"
                    :max="50"
                    size="mini"
                  ></el-input-number>
                </el-tooltip>
              </div>
              <div class="li-input">
                <el-input v-model="title"></el-input>
              </div>
            </div>
          </div>
          <!-- 内容字体改变 -->
          <div class="data-li clearfix">
            <div class="li-name">{{ $t("bulkmail.text") }}</div>
            <div class="li-value">
              <div class="li-tool clearfix">
                <el-tooltip :content="$t('pop.bfont')" placement="top">
                  <div
                    :class="['tool-module', 'tool-module1', { active: font2B }]"
                    @click="changeFontB2"
                  ></div>
                </el-tooltip>
                <el-tooltip :content="$t('pop.ifont')" placement="top">
                  <div
                    :class="['tool-module', 'tool-module2', { active: font2I }]"
                    @click="changeFontI2"
                  ></div>
                </el-tooltip>
                <div class="tool-module tool-module3">
                  <el-color-picker v-model="color2" size="mini"></el-color-picker>
                </div>
                <el-tooltip :content="$t('pop.lffont')" placement="top">
                  <div
                    :class="['tool-module', 'tool-module4', { active: nowIndex2 === 4 }]"
                    @click="changeFont2(4)"
                  ></div>
                </el-tooltip>
                <el-tooltip :content="$t('pop.centerfont')" placement="top">
                  <div
                    :class="['tool-module', 'tool-module5', { active: nowIndex2 === 5 }]"
                    @click="changeFont2(5)"
                  ></div>
                </el-tooltip>
                <el-tooltip :content="$t('pop.lrfont')" placement="top">
                  <div
                    :class="['tool-module', 'tool-module6', { active: nowIndex2 === 6 }]"
                    @click="changeFont2(6)"
                  ></div>
                </el-tooltip>
                <el-tooltip :content="$t('pop.font')" placement="top">
                  <el-input-number
                    v-model="fontSize2"
                    :min="12"
                    :max="50"
                    size="mini"
                  ></el-input-number>
                </el-tooltip>
              </div>
              <div class="li-input">
                <el-input
                  v-model="content"
                  type="textarea"
                  resize="none"
                  rows="4"
                ></el-input>
              </div>
            </div>
          </div>
          <!-- 页尾 -->
          <div class="data-li clearfix">
            <div class="li-name">{{ $t("pop.titleFooter") }}</div>
            <div class="li-value">
              <div class="li-tool clearfix">
                <el-tooltip :content="$t('pop.bfont')" placement="top">
                  <div
                    :class="['tool-module', 'tool-module1', { active: font3B }]"
                    @click="changeFontB3"
                  ></div>
                </el-tooltip>
                <el-tooltip :content="$t('pop.ifont')" placement="top">
                  <div
                    :class="['tool-module', 'tool-module2', { active: font3I }]"
                    @click="changeFontI3"
                  ></div>
                </el-tooltip>
                <div class="tool-module tool-module3">
                  <el-color-picker v-model="color3" size="mini"></el-color-picker>
                </div>
                <el-tooltip :content="$t('pop.lffont')" placement="top">
                  <div
                    :class="['tool-module', 'tool-module4', { active: nowIndex3 === 4 }]"
                    @click="changeFont3(4)"
                  ></div>
                </el-tooltip>
                <el-tooltip :content="$t('pop.centerfont')" placement="top">
                  <div
                    :class="['tool-module', 'tool-module5', { active: nowIndex3 === 5 }]"
                    @click="changeFont3(5)"
                  ></div>
                </el-tooltip>
                <el-tooltip :content="$t('pop.lrfont')" placement="top">
                  <div
                    :class="['tool-module', 'tool-module6', { active: nowIndex3 === 6 }]"
                    @click="changeFont3(6)"
                  ></div>
                </el-tooltip>
                <el-tooltip :content="$t('pop.font')" placement="top">
                  <el-input-number
                    v-model="fontSize3"
                    :min="12"
                    :max="50"
                    size="mini"
                  ></el-input-number>
                </el-tooltip>
              </div>
              <div class="li-input">
                <el-input v-model="footer"></el-input>
              </div>
            </div>
          </div>
          <div class="module-img-buttons">
            <el-button
              class="tool-button tool-button-info"
              type="info"
              :disabled="disabled"
              @click="backEdit"
            >
              {{ $t("course.return") }}
            </el-button>
            <el-button
              class="tool-button"
              type="primary"
              @click="saveImg"
              :disabled="disabled"
            >
              {{ $t("confirm") }}
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VueDragResize from "vue-drag-resize";
import html2canvas from "html2canvas";

export default {
  components: {
    VueDragResize,
  },
  props: {
    dialogShow: {
      type: Boolean,
    },
  },
  data() {
    return {
      moduleLoading: false,
      imgSrc: "",
      imgUrl: "",
      title: "标题",
      content: "正文内容",
      footer: "页尾",
      nowIndex: -1,
      moduleStep: false,
      height: 12,
      height2: 12,
      height3: 12,
      width2: 300,
      fontSize1: 12,
      fontSize2: 12,
      fontSize3: 12,
      color1: "#000000",
      color2: "#000000",
      color3: "#000000",
      font1B: false,
      font1I: false,
      font2B: false,
      font2I: false,
      font3B: false,
      font3I: false,
      nowIndex1: 5,
      nowIndex2: 5,
      nowIndex3: 5,
      font1align: "center",
      font2align: "center",
      font3align: "center",
      moduleList: [],
      disabled: false,
    };
  },
  methods: {
    // 获取图片地址
    getImgSrc() {
      this.moduleLoading = true;
      this.$request.get("/sys/popsUpMsg/getTempImages").then((res) => {
        if (res) {
          this.moduleList = Object.values(res).map((item) => {
            return { url: item };
          });
          this.moduleLoading = false;
        }
      });
    },
    choseImg(val) {
      this.nowIndex = val;
      this.imgSrc = this.moduleList[val].url;
    },
    resetImg() {
      this.nowIndex = -1;
      this.imgSrc = "";
    },
    goNext() {
      this.moduleStep = true;
    },
    handleClose() {
      this.imgSrc = "";
      this.$emit("closeHandle", false);
    },
    closeChose() {
      this.imgSrc = "";
      this.$emit("closeHandle", false);
    },
    backEdit() {
      this.imgSrc = "";
      this.$emit("closeHandle", false);
    },
    // 标题的字体修改
    changeFontB1() {
      this.font1B = !this.font1B;
    },
    changeFontI1() {
      this.font1I = !this.font1I;
    },
    changeFont1(val) {
      this.nowIndex1 = val;
      let align = "center";
      switch (val) {
        case 4:
          align = "left";
          break;
        case 5:
          align = "center";
          break;
        case 6:
          align = "right";
          break;
        default:
          break;
      }
      this.font1align = align;
    },
    // 内容的字体修改
    changeFontB2() {
      this.font2B = !this.font2B;
    },
    changeFontI2() {
      this.font2I = !this.font2I;
    },
    changeFont2(val) {
      this.nowIndex2 = val;
      let align = "center";
      switch (val) {
        case 4:
          align = "left";
          break;
        case 5:
          align = "center";
          break;
        case 6:
          align = "right";
          break;
        default:
          break;
      }
      this.font2align = align;
    },
    // 页尾的字体修改
    changeFontB3() {
      this.font3B = !this.font3B;
    },
    changeFontI3() {
      this.font3I = !this.font3I;
    },
    changeFont3(val) {
      this.nowIndex3 = val;
      let align = "center";
      switch (val) {
        case 4:
          align = "left";
          break;
        case 5:
          align = "center";
          break;
        case 6:
          align = "right";
          break;
        default:
          break;
      }
      this.font3align = align;
    },
    resize(val) {
      this.height = val.height;
    },
    resize2(val) {
      this.height2 = val.height;
      this.width2 = val.width;
    },
    resize3(val) {
      this.height3 = val.height;
    },
    saveImg() {
      this.disabled = true;
      window.pageYoffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      html2canvas(this.$refs.moduleImg).then((canvas) => {
        let dataURL = canvas.toDataURL("image/png");
        this.imgUrl = dataURL;
        this.disabled = false;
        let moduleName = "模板" + new Date().getTime() + ".png";
        let bytes = window.atob(dataURL.split(",")[1]);
        let array = [];
        for (var i = 0; i < bytes.length; i++) {
          array.push(bytes.charCodeAt(i));
        }
        let blob = new Blob([new Uint8Array(array)], { type: "image/png" });
        let formData = new FormData();
        formData.append("file", blob);
        // 上传图片到云服务器
        this.$request
          .post(
            `/file/uploadFile?fileName=${moduleName}&containerName=resource&type=3`,
            formData
          )
          .then((res) => {
            if (res) {
              this.$emit("closeHandle", { imgUrl: res });
            }
          });
      });
    },
  },
  mounted() {
    this.getImgSrc();
  },
};
</script>
<style lang="scss" scoped>
.module-modal-contain {
  .module-modal-page {
    height: 100%;
    &.module-modal-page2 {
      display: flex;
      flex-wrap: wrap;
      .module-img {
        border: 1px dashed #dcdfe6;
        border-radius: 3px;
        width: 250px;
        height: 345px;
        margin-right: 30px;
        margin-bottom: 20px;
        cursor: pointer;
        position: relative;
        .img-check {
          position: absolute;
          right: 0;
          top: 0;
          color: #ffffff;
          font-size: 16px;
          background-color: #3ecb42;
        }
        img {
          width: 100%;
          height: 100%;
        }
        &.nomargin {
          margin-right: 0;
        }
        &:hover {
          opacity: 0.9;
        }
        &.active {
          border: 1px dashed #3ecb42;
        }
      }
    }
    .module-img-edit {
      width: 434px;
      height: 600px;
      margin: 0 auto;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border: 1px solid #dcdfe6;
      border-radius: 3px;
      position: relative;
      .img-back {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
      }
      .vdr {
        cursor: move;
      }
      .vdr.active:before {
        outline: 2px dashed #d6d6d6 !important;
      }
      .img-edit-content-title {
        font-size: 14px;
        margin: 0;
        &.bold {
          font-weight: bold;
        }
        &.font-i {
          font-style: italic;
        }
        &.font-sj {
          text-indent: 2em;
        }
      }
    }
    .module-img-data {
      margin: 20px 0;
      .data-li {
        margin-bottom: 20px;
        .li-name {
          width: 40px;
          float: left;
          line-height: 30px;
          margin-right: 20px;
        }
        .li-value {
          width: calc(100% - 60px);
          float: left;
          .li-tool {
            margin-bottom: 6px;
            .tool-module {
              width: 28px;
              height: 28px;
              float: left;
              margin-right: 10px;
              cursor: pointer;
              border: 1px solid #e6e6e6;
              border-radius: 4px;
              &.active {
                background-color: #dcdfe6 !important;
              }
              &:hover {
                opacity: 0.7;
              }
              &.tool-module1 {
                background: url("~@/assets/img/b_font.png") no-repeat center center/60%;
              }
              &.tool-module2 {
                background: url("~@/assets/img/i_font.png") no-repeat center center/60%;
              }
              &.tool-module3 {
                border: none;
              }
              &.tool-module4 {
                background: url("~@/assets/img/text_left.png") no-repeat center center/60%;
              }
              &.tool-module5 {
                background: url("~@/assets/img/text_center.png") no-repeat center
                  center/60%;
              }
              &.tool-module6 {
                background: url("~@/assets/img/text_right.png") no-repeat center
                  center/60%;
              }
            }
          }
        }
      }
    }
    .module-img-buttons {
      width: 100%;
      margin: 20px 0;
      text-align: center;
    }
  }
}
</style>
<style lang="scss">
.module-modal-contain {
  .el-input--mini .el-input__inner {
    width: 130px !important;
    height: 28px !important;
    line-height: 28px !important;
    min-height: 28px !important;
  }
}
</style>
